import { useQuery } from '@apollo/client';
import {
    WorldMapStories,
    WorldMapStoriesVariables
} from 'graphql/query/__generated__/WorldMapStories';
import { WORLD_MAP_STORIES } from 'graphql/query/worldQuery';
import { useViewMapQueryParams } from 'hooks/map/useViewMapQueryParams';
import { useWorldMapLocalStorage } from 'libs/hooks/ownership/useWorldMapLocalStorage';
import { useContext, useEffect } from 'react';
import { CtxView } from 'session/ctxView';

export const useLoadDetails = (mapId: string, opts: { skip: boolean }) => {
    const ctxView = useContext(CtxView);
    const { getTokenForMapId } = useWorldMapLocalStorage();
    const params = useViewMapQueryParams();
    const allMapDetails = useQuery<WorldMapStories, WorldMapStoriesVariables>(WORLD_MAP_STORIES, {
        variables: { worldMapId: mapId, token: getTokenForMapId(mapId), language: params.language },
        skip: !mapId || opts.skip
    });

    useEffect(() => {
        if (allMapDetails.data?.publishedStoriesForWorldMap) {
            const allDetails = allMapDetails.data?.publishedStoriesForWorldMap;

            ctxView.setAllDetails(allDetails);
        }
    }, [allMapDetails.data?.publishedStoriesForWorldMap, mapId]);
};
